import { axiosInstance } from "@/lib/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from '@/hooks/use-toast';
import type { Offer } from '@/types/Offer';

const offerAdd = async (velId, body: Partial<Offer>) => {
  const { data } = await axiosInstance.post(
    `/api/abo/vel/${velId}/offer`
    , body
  );
  return data;
};

export const useOfferAdd = ({velId}) => {
  const {toast} = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: Partial<Offer>) =>
      offerAdd(velId, body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["vel", velId, 'offers'],
      });
      toast({
        variant: "default",
        title: "La bannière a été ajoutée",
      });
    },
    onError: () => {
      toast({
        title: "Il y a un problème",
        variant: "destructive",
      });
    },
  });
};

